var _ItemList;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable react/no-unstable-nested-components */
import React, { PureComponent } from 'react';
import memoize from 'memoizee';
import { FixedSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import Log from '@deephaven/log';
import { RangeUtils } from '@deephaven/utils';
import ItemListItem from "./ItemListItem.js";
import { ContextActionUtils } from "./context-actions/index.js";
import "./ItemList.css";
import { jsx as _jsx } from "react/jsx-runtime";
var log = Log.module('ItemList');
var MIN_DRAG_DELTA = 5;
/**
 * Show items in a long scrollable list.
 * Can be navigated via keyboard or mouse.
 */
export class ItemList extends PureComponent {
  static renderItem(_ref) {
    var _ref2, _item$displayValue;
    var item = _ref.item;
    return /*#__PURE__*/_jsx("div", {
      className: "item-list-item-content",
      children: item != null && ((_ref2 = (_item$displayValue = item.displayValue) !== null && _item$displayValue !== void 0 ? _item$displayValue : item.value) !== null && _ref2 !== void 0 ? _ref2 : "".concat(item))
    });
  }
  constructor(_props) {
    super(_props);
    _defineProperty(this, "list", void 0);
    _defineProperty(this, "listContainer", void 0);
    _defineProperty(this, "getItemSelected", memoize((index, selectedRanges) => RangeUtils.isSelected(selectedRanges, index), {
      max: ItemList.CACHE_SIZE
    }));
    _defineProperty(this, "getCachedItem", memoize((itemIndex, key, item, isFocused, isSelected, renderItem, style, disableSelect) => {
      var content = renderItem({
        item,
        itemIndex,
        isFocused,
        isSelected,
        style
      });
      return /*#__PURE__*/_jsx(ItemListItem, {
        onContextMenu: this.handleItemContextMenu,
        onDoubleClick: this.handleItemDoubleClick,
        onMouseDown: this.handleItemMouseDown,
        onFocus: this.handleItemFocus,
        onBlur: this.handleItemBlur,
        disableSelect: disableSelect,
        onMouseMove: this.handleItemMouseMove,
        onMouseUp: this.handleItemMouseUp,
        isFocused: isFocused,
        isSelected: isSelected,
        itemIndex: itemIndex,
        style: style,
        children: content
      }, key);
    }, {
      max: ItemList.CACHE_SIZE
    }));
    _defineProperty(this, "getOuterElement", memoize(onKeyDown => {
      var component = /*#__PURE__*/React.forwardRef((props, ref) =>
      /*#__PURE__*/
      // We need to add the tabIndex to make sure it is focusable, otherwise we can't get key events
      _jsx("div", _objectSpread({
        ref: ref,
        tabIndex: -1,
        onKeyDown: onKeyDown,
        role: "presentation"
        // eslint-disable-next-line react/jsx-props-no-spreading
      }, props)));
      component.displayName = 'ItemListOuterElement';
      return component;
    }, {
      max: 1000
    }));
    _defineProperty(this, "getInnerElement", memoize(() => {
      var component = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/_jsx("div", _objectSpread({
        className: "item-list-inner-element",
        ref: ref
        // eslint-disable-next-line react/jsx-props-no-spreading
      }, props)));
      component.displayName = 'ItemListInnerElement';
      return component;
    }, {
      max: 1000
    }));
    _defineProperty(this, "getItemData", memoize((items, selectedRanges, renderItem) => ({
      items,
      selectedRanges,
      renderItem
    }), {
      max: 1000
    }));
    this.handleItemBlur = this.handleItemBlur.bind(this);
    this.handleItemContextMenu = this.handleItemContextMenu.bind(this);
    this.handleItemFocus = this.handleItemFocus.bind(this);
    this.handleItemDoubleClick = this.handleItemDoubleClick.bind(this);
    this.handleItemMouseDown = this.handleItemMouseDown.bind(this);
    this.handleItemMouseMove = this.handleItemMouseMove.bind(this);
    this.handleItemMouseUp = this.handleItemMouseUp.bind(this);
    this.handleItemsRendered = this.handleItemsRendered.bind(this);
    this.handleWindowMouseUp = this.handleWindowMouseUp.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.renderInnerElement = this.renderInnerElement.bind(this);
    this.list = /*#__PURE__*/React.createRef();
    this.listContainer = /*#__PURE__*/React.createRef();
    var isStickyBottom = _props.isStickyBottom,
      _selectedRanges = _props.selectedRanges;
    this.state = {
      focusIndex: null,
      mouseDownIndex: null,
      selectedRanges: _selectedRanges,
      overscanStartIndex: 0,
      height: null,
      isDragging: false,
      isStuckToBottom: isStickyBottom,
      scrollOffset: null,
      mouseX: null,
      mouseY: null
    };
  }
  componentDidUpdate(prevProps, prevState) {
    var _this$props = this.props,
      propSelectedRanges = _this$props.selectedRanges,
      itemCount = _this$props.itemCount;
    var _this$state = this.state,
      focusIndex = _this$state.focusIndex,
      isStuckToBottom = _this$state.isStuckToBottom,
      scrollOffset = _this$state.scrollOffset,
      height = _this$state.height,
      selectedRanges = _this$state.selectedRanges;
    if (isStuckToBottom && !this.isListAtBottom() && itemCount > 0) {
      this.scrollToBottom();
    }
    if (scrollOffset !== prevState.scrollOffset || height !== prevState.height) {
      this.sendViewportUpdate();
    }
    if (propSelectedRanges !== prevProps.selectedRanges && propSelectedRanges !== selectedRanges) {
      this.setSelectedRanges(propSelectedRanges);
    } else if (selectedRanges !== prevState.selectedRanges) {
      var onSelectionChange = this.props.onSelectionChange;
      onSelectionChange(selectedRanges);
    }
    if (focusIndex !== prevState.focusIndex) {
      var onFocusChange = this.props.onFocusChange;
      onFocusChange(focusIndex);
    }
  }
  componentWillUnmount() {
    window.removeEventListener('mouseup', this.handleWindowMouseUp);
  }
  focus() {
    var _this$listContainer$c;
    (_this$listContainer$c = this.listContainer.current) === null || _this$listContainer$c === void 0 || _this$listContainer$c.focus();
  }
  restoreScrollPosition() {
    var container = this.listContainer.current;
    if (container == null) {
      return;
    }
    var scrollOffset = this.state.scrollOffset;
    if (scrollOffset == null) {
      return;
    }

    // Re-parenting the panel (e.g. removing a sibling panel) resets the scroll
    // container to the top while react-window keeps its internal offset, which
    // leaves the list blank. Re-assert the scroll position from the current
    // geometry. If the list is stuck to the bottom, snap to the (new) bottom so
    // a shrinking panel doesn't cut off the latest items; otherwise clamp the
    // last real offset to the current bounds.
    var _this$props2 = this.props,
      itemCount = _this$props2.itemCount,
      rowHeight = _this$props2.rowHeight;
    var _this$state2 = this.state,
      height = _this$state2.height,
      isStuckToBottom = _this$state2.isStuckToBottom;
    var maxOffset = Math.max(0, itemCount * rowHeight - (height !== null && height !== void 0 ? height : 0));
    var newOffset = isStuckToBottom ? maxOffset : Math.min(Math.max(scrollOffset, 0), maxOffset);
    container.scrollTo(0, newOffset);
  }
  getElement(itemIndex) {
    if (this.listContainer.current == null) {
      return null;
    }
    var focusSelector = this.props.focusSelector;
    var overscanStartIndex = this.state.overscanStartIndex;
    var elements = this.listContainer.current.querySelectorAll(focusSelector);
    var elementIndex = itemIndex - overscanStartIndex;
    return elements[elementIndex];
  }
  focusItem(itemIndex) {
    var disableSelect = this.props.disableSelect;
    if (disableSelect) return;
    this.setState({
      focusIndex: itemIndex
    });
    var element = this.getElement(itemIndex);
    if (element instanceof HTMLElement) {
      element.focus();
    }
  }
  scrollToItem(itemIndex) {
    var element = this.getElement(itemIndex);
    if (element != null) {
      element.scrollIntoView({
        block: 'center'
      });
    }
  }
  handleItemContextMenu(itemIndex, e) {
    this.setState({
      focusIndex: itemIndex
    });

    // Update the selection, but don't consume the mouse event - it will trigger the context menu
    var selectedRanges = this.state.selectedRanges;
    var isSelected = RangeUtils.isSelected(selectedRanges, itemIndex);

    // When right-clicking, we want to maintain the current selection if the right click happened within the selection even if the modifier key isn't down
    var isModifierDown = isSelected || ContextActionUtils.isModifierKeyDown(e);
    this.toggleSelect(itemIndex, e.shiftKey, isModifierDown, false);
  }
  handleItemDoubleClick(itemIndex, e) {
    var _this$props3 = this.props,
      isDoubleClickSelect = _this$props3.isDoubleClickSelect,
      onSelect = _this$props3.onSelect;
    if (isDoubleClickSelect) {
      this.setState(_ref3 => {
        var selectedRanges = _ref3.selectedRanges;
        return {
          selectedRanges: RangeUtils.selectRange(selectedRanges, [itemIndex, itemIndex])
        };
      }, () => {
        onSelect(itemIndex, e);
      });
    }
  }
  handleItemMouseDown(index, e) {
    var selectedRanges = this.state.selectedRanges;
    if (e.target instanceof HTMLElement && ['button', 'select', 'input', 'textarea'].indexOf(e.target.tagName.toLowerCase()) !== -1) {
      // allow these elements to do their own behaviours
      return;
    }
    if (e.button === 2 && selectedRanges.length === 0) {
      // allow right click to act as a selection if selection is empty
      this.focusItem(index);
      this.selectItem(index);
      return;
    }
    if (e.button != null && e.button !== 0) {
      return;
    }
    this.setState({
      mouseDownIndex: index,
      mouseX: e.clientX,
      mouseY: e.clientY
    });
    window.addEventListener('mouseup', this.handleWindowMouseUp);

    // Leave selection until mouse up, to allow for dragging behaviour
  }
  handleItemBlur(itemIndex, e) {
    log.debug2('item blur', itemIndex, e.currentTarget, e.relatedTarget);
    if (!e.relatedTarget || this.listContainer.current && e.relatedTarget instanceof HTMLElement && !this.listContainer.current.contains(e.relatedTarget)) {
      // Next focused element is outside of the ItemList
      this.setState({
        focusIndex: null
      });
    }
  }
  handleItemFocus(itemIndex, e) {
    log.debug2('item focus', itemIndex, e.target);
    this.setState(state => {
      var focusIndex = state.focusIndex;
      if (focusIndex !== itemIndex) {
        return {
          focusIndex: itemIndex
        };
      }
      return null;
    });
  }
  handleItemMouseMove(itemIndex, e) {
    var _this$props4 = this.props,
      isDragSelect = _this$props4.isDragSelect,
      isMultiSelect = _this$props4.isMultiSelect,
      disableSelect = _this$props4.disableSelect;
    var _this$state3 = this.state,
      mouseDownIndex = _this$state3.mouseDownIndex,
      selectedRanges = _this$state3.selectedRanges,
      mouseX = _this$state3.mouseX,
      mouseY = _this$state3.mouseY;
    if (mouseDownIndex == null || disableSelect) return;
    var mouseMoveX = Math.abs(e.clientX - (mouseX !== null && mouseX !== void 0 ? mouseX : 0));
    var mouseMoveY = Math.abs(e.clientY - (mouseY !== null && mouseY !== void 0 ? mouseY : 0));
    if (mouseMoveX > MIN_DRAG_DELTA && mouseMoveY > MIN_DRAG_DELTA) {
      this.setState({
        isDragging: true
      });
    }
    if (isDragSelect || mouseDownIndex === itemIndex) {
      this.focusItem(itemIndex);
      if (isMultiSelect) {
        if (!isDragSelect && !this.getItemSelected(itemIndex, selectedRanges) && !ContextActionUtils.isModifierKeyDown(e)) {
          // If there's already a selection and they select outside of that range while dragging without a modifier key, start a new selection with just the new item
          this.deselectAll();
        }
        this.selectRange([Math.min(mouseDownIndex, itemIndex), Math.max(mouseDownIndex, itemIndex)]);
      } else {
        this.toggleSelect(itemIndex, e.shiftKey, ContextActionUtils.isModifierKeyDown(e), false);
      }
    }
  }
  handleItemMouseUp(index, e) {
    var _this$props5 = this.props,
      isDeselectOnClick = _this$props5.isDeselectOnClick,
      isDoubleClickSelect = _this$props5.isDoubleClickSelect,
      onSelect = _this$props5.onSelect;
    var _this$state4 = this.state,
      mouseDownIndex = _this$state4.mouseDownIndex,
      isDragging = _this$state4.isDragging;
    if (e.target instanceof HTMLElement && ['button', 'select', 'input', 'textarea'].indexOf(e.target.tagName.toLowerCase()) !== -1) {
      return;
    }
    if (mouseDownIndex === index && !isDragging) {
      var isShiftDown = e.shiftKey;
      var isModifierDown = ContextActionUtils.isModifierKeyDown(e);
      this.focusItem(index);
      this.toggleSelect(index, isShiftDown, isModifierDown, isDeselectOnClick);
      if (!isDoubleClickSelect && !isShiftDown && !isModifierDown) {
        onSelect(index, e);
      }
    }
    this.resetMouseState();
  }
  handleItemsRendered(_ref4) {
    var overscanStartIndex = _ref4.overscanStartIndex;
    this.setState({
      overscanStartIndex
    });
  }
  handleResize(_ref5) {
    var height = _ref5.height;
    this.setState({
      height
    }, () => {
      this.restoreScrollPosition();
    });
  }
  handleMouseLeave() {
    this.setState({
      mouseDownIndex: null
    });
  }
  handleWindowMouseUp() {
    this.resetMouseState();
    window.removeEventListener('mouseup', this.handleWindowMouseUp);
  }
  handleKeyDown(e) {
    var _this$props6 = this.props,
      isMultiSelect = _this$props6.isMultiSelect,
      itemCount = _this$props6.itemCount,
      onSelect = _this$props6.onSelect;
    var oldFocus = this.state.focusIndex;
    var newFocus = oldFocus;
    if (e.key === 'Enter' || e.key === ' ') {
      if (!isMultiSelect && newFocus != null) {
        this.setState({
          selectedRanges: [[newFocus, newFocus]]
        }, () => {
          if (newFocus != null) {
            onSelect(newFocus, e);
          }
        });
      }
      return;
    }
    if (e.key === 'ArrowUp') {
      if (newFocus != null && newFocus >= 0) {
        newFocus = Math.max(0, newFocus - 1);
      } else {
        newFocus = itemCount - 1;
      }
    } else if (e.key === 'ArrowDown') {
      if (newFocus != null && newFocus >= 0) {
        newFocus = Math.min(newFocus + 1, itemCount - 1);
      } else {
        newFocus = 0;
      }
    } else {
      return;
    }
    if (oldFocus !== newFocus) {
      e.stopPropagation();
      e.preventDefault();
      this.focusItem(newFocus);
      var selectedRanges = this.state.selectedRanges;
      if (e.shiftKey && selectedRanges.length > 0) {
        var lastRange = selectedRanges[selectedRanges.length - 1];
        this.selectRange([Math.min(newFocus, lastRange[0]), Math.max(newFocus, lastRange[1])]);
      } else {
        this.deselectAll();
        if (newFocus !== null) {
          this.selectItem(newFocus);
        } else {
          var _this$listContainer$c2;
          (_this$listContainer$c2 = this.listContainer.current) === null || _this$listContainer$c2 === void 0 || _this$listContainer$c2.focus();
        }
      }
      this.scrollIntoView(newFocus);
    }
  }
  handleScroll(_ref6) {
    var scrollUpdateWasRequested = _ref6.scrollUpdateWasRequested,
      scrollOffset = _ref6.scrollOffset;
    this.setState(state => {
      if (scrollUpdateWasRequested) {
        // The scroll was caused by scrollTo() or scrollToItem()
        // Don't re-calc isStuckToBottom
        return {
          scrollOffset
        };
      }
      var isStickyBottom = this.props.isStickyBottom;
      var height = state.height;
      var isStuckToBottom = isStickyBottom && this.isListAtBottom({
        scrollOffset,
        height
      });
      return {
        isStuckToBottom,
        scrollOffset
      };
    });
  }
  resetMouseState() {
    this.setState({
      mouseDownIndex: null,
      isDragging: false
    });
  }
  scrollToBottom() {
    var itemCount = this.props.itemCount;
    if (this.list.current) {
      this.list.current.scrollToItem(itemCount);
    }
  }
  scrollIntoView(itemIndex) {
    if (this.list.current) {
      this.list.current.scrollToItem(itemIndex);
    }
  }

  /**
   * @param index The index to toggle selection for
   * @param isShiftDown True if the shift modifier key is down
   * @param isModifierDown True if the meta modifier key is down
   * @param isDeselectable True if item should be deselected if already selected
   */
  toggleSelect(index, isShiftDown, isModifierDown) {
    var isDeselectable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var isMultiSelect = this.props.isMultiSelect;
    var selectedRanges = this.state.selectedRanges;
    if (isMultiSelect && isShiftDown && selectedRanges.length > 0) {
      var lastRange = selectedRanges[selectedRanges.length - 1];
      this.selectRange([Math.min(lastRange[0], index), Math.max(index, lastRange[1])]);
    } else if (isMultiSelect && selectedRanges.length === 1 && selectedRanges[0][0] === index && selectedRanges[0][1] === index) {
      if (isDeselectable) {
        this.deselectItem(index);
      }
    } else if (isMultiSelect && isModifierDown) {
      if (this.getItemSelected(index, selectedRanges)) {
        if (isDeselectable) {
          this.deselectItem(index);
        }
      } else {
        this.selectItem(index);
      }
    } else {
      this.deselectAll();
      this.selectItem(index);
    }
  }
  deselectAll() {
    var itemCount = this.props.itemCount;
    this.deselectRange([0, itemCount]);
  }
  deselectItem(index) {
    this.deselectRange([index, index]);
  }
  deselectRange(range) {
    RangeUtils.validateRange(range);
    this.setState(_ref7 => {
      var selectedRanges = _ref7.selectedRanges;
      return {
        selectedRanges: RangeUtils.deselectRange(selectedRanges, range)
      };
    });
  }
  selectItem(index) {
    var disableSelect = this.props.disableSelect;
    if (disableSelect) return;
    this.selectRange([index, index]);
  }
  selectRange(range) {
    RangeUtils.validateRange(range);
    this.setState(_ref8 => {
      var selectedRanges = _ref8.selectedRanges;
      return {
        selectedRanges: RangeUtils.selectRange(selectedRanges, range)
      };
    });
  }
  setSelectedRanges(selectedRanges) {
    this.setState({
      selectedRanges
    });
  }
  sendViewportUpdate() {
    var _this$state5 = this.state,
      scrollOffset = _this$state5.scrollOffset,
      height = _this$state5.height;
    if (scrollOffset != null && height != null) {
      var _this$props7 = this.props,
        onViewportChange = _this$props7.onViewportChange,
        rowHeight = _this$props7.rowHeight;
      var topRow = Math.floor(scrollOffset / rowHeight);
      var bottomRow = topRow + Math.ceil(height / rowHeight);
      onViewportChange(topRow, bottomRow);
    }
  }
  isListAtBottom() {
    var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state,
      scrollOffset = _ref9.scrollOffset,
      height = _ref9.height;
    if (height == null || scrollOffset == null) {
      return false;
    }
    var _this$props8 = this.props,
      itemCount = _this$props8.itemCount,
      rowHeight = _this$props8.rowHeight;
    return scrollOffset + height >= itemCount * rowHeight - 1; // Use a 1px tolerance
  }
  renderInnerElement(_ref0) {
    var itemIndex = _ref0.index,
      style = _ref0.style;
    var _this$props9 = this.props,
      items = _this$props9.items,
      offset = _this$props9.offset,
      renderItem = _this$props9.renderItem,
      disableSelect = _this$props9.disableSelect;
    var _this$state6 = this.state,
      focusIndex = _this$state6.focusIndex,
      selectedRanges = _this$state6.selectedRanges;
    if (itemIndex < offset || itemIndex >= offset + items.length) {
      return null;
    }
    var item = items[itemIndex - offset];
    return this.getCachedItem(itemIndex, itemIndex, item, itemIndex === focusIndex && !disableSelect, this.getItemSelected(itemIndex, selectedRanges), renderItem, style, disableSelect);
  }
  render() {
    var _this$props0 = this.props,
      items = _this$props0.items,
      itemCount = _this$props0.itemCount,
      overscanCount = _this$props0.overscanCount,
      renderItem = _this$props0.renderItem,
      rowHeight = _this$props0.rowHeight,
      dataTestId = _this$props0['data-testid'];
    var _this$state7 = this.state,
      selectedRanges = _this$state7.selectedRanges,
      isStuckToBottom = _this$state7.isStuckToBottom;
    return /*#__PURE__*/_jsx(AutoSizer, {
      className: "item-list-auto-sizer",
      onResize: this.handleResize,
      children: _ref1 => {
        var width = _ref1.width,
          height = _ref1.height;
        return /*#__PURE__*/_jsx(List, {
          className: "item-list-scroll-pane",
          height: height,
          width: width,
          initialScrollOffset: isStuckToBottom ? itemCount * rowHeight : 0,
          itemCount: itemCount,
          itemSize: rowHeight
          // This prop isn't actually used by us, it is passed to the render function by react-window
          // Used here to force a re-render of the List component.
          // Otherwise it doesn't know to call the render again when selection or renderItem changes
          ,
          itemData: this.getItemData(items, selectedRanges, renderItem),
          onScroll: this.handleScroll,
          onItemsRendered: this.handleItemsRendered,
          ref: this.list,
          outerElementType: this.getOuterElement(this.handleKeyDown),
          outerRef: this.listContainer,
          innerElementType: this.getInnerElement(),
          overscanCount: overscanCount,
          "data-testid": dataTestId,
          children: this.renderInnerElement
        });
      }
    });
  }
}
_ItemList = ItemList;
_defineProperty(ItemList, "CACHE_SIZE", 1000);
_defineProperty(ItemList, "DEFAULT_ROW_HEIGHT", 20);
// By drawing an additional 10 items on each side, tab/keyboard navigation works better (as the next element exists)
_defineProperty(ItemList, "DEFAULT_OVERSCAN", 10);
_defineProperty(ItemList, "defaultProps", {
  offset: 0,
  items: [],
  rowHeight: _ItemList.DEFAULT_ROW_HEIGHT,
  isDeselectOnClick: true,
  isDoubleClickSelect: false,
  isDragSelect: true,
  isMultiSelect: false,
  isStickyBottom: false,
  disableSelect: false,
  onFocusChange() {
    // no-op
  },
  onSelect() {
    // no-op
  },
  onSelectionChange() {
    // no-op
  },
  onViewportChange() {
    // no-op
  },
  overscanCount: _ItemList.DEFAULT_OVERSCAN,
  renderItem: _ItemList.renderItem,
  selectedRanges: [],
  focusSelector: '.item-list-item',
  'data-testid': undefined
});
export default ItemList;
//# sourceMappingURL=ItemList.js.map